import Edit from "./Edit.js";
import List from "./List.js";
import Show from "./Show.js";
import Create from "./Create.js";

export default { List, Show, Edit, Create };
